// Colors
export const mainColor = '#ffffff';

// UI Selectors
export const appContainer = '#app';
export const contentContainer = '#content-container';
export const uiContainer = '#ui-container';
export const backgroundContainer = '#background-container';

// Should match value defined in app.scss
export const phoneBoundary = 600;

// Is the site being run in a prerendering context?
export const prerender = (window as any).PRERENDER;

// Is the site running on a localhost or 0.0.0.0 url?
export const local = (window as any).LOCAl;

export const base = (window as any).BASE;

// Base root path.
// this project is hosted in a subdir in production. (only)
const getRootPath = () => {
  if (local || prerender || base === '/') return `/`;
  const root = new URL(base).pathname.split('/')[1];
  return root ? `/${root}/` : `/`;
};

export const rootPath = getRootPath();

export const supportedLanguages = ['en', 'es'];

export const getLanguage = () => (window as any).LANGUAGE || supportedLanguages[0];

export const ie11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;

if (ie11) {
  document.documentElement.classList.add('ie11');
}
